import React, { Fragment } from 'react';

import { ObjectFieldTemplateProps } from '@rjsf/core';
import { AccordionObjectFieldProvider } from './AccordionObjectFieldContext';
import { Divider } from 'semantic-ui-react';
import ObjectFieldTemplate from '../../../../../sg-schema/themes/semantic/templates/ObjectFieldTemplate';
import "./_AccordionObjectField.less";


const AccordionObjectField = (props: ObjectFieldTemplateProps) => {

  // Prevents infinite loop
  let uiSchema = props.uiSchema;
  uiSchema["ui:objectTemplate"] = "";

  return (
    <Fragment>
      <AccordionObjectFieldProvider>
        <ObjectFieldTemplate {...props} uiSchema={uiSchema} />
      </AccordionObjectFieldProvider>
      <Divider hidden />
      <Divider hidden />
      <Divider hidden />
    </Fragment>
  )
};

export default AccordionObjectField;
